export const mode = {
    ADD: 'Add',
    EDIT: 'Edit',
    COPY: 'Copy'
};